module.exports = __webpack_public_path__ + "static/img/12.0876ad7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/eng/12.png
// module id = yaHW
// module chunks = 0